class BSO_ADD_TO_CART_PRICE extends HTMLElement {
  constructor() {
    super();

    this.config = JSON.parse(this.getAttribute("data-config") || null);
    this.format = this.getAttribute('data-money-format');
  }

  connectedCallback() {
    document.addEventListener("quantity:changed", this.replacePrice.bind(this));
    document.addEventListener("quantity:changed:bulk:button", this.replacePrice.bind(this));
  }

  formatMoney(cents, format) {
    if (typeof cents == "string") {
      cents = cents.replace(".", "");
    }
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || this.money_format;

    function defaultOption(opt, def) {
      return typeof opt == "undefined" ? def : opt;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ",");
      decimal = defaultOption(decimal, ".");

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.00).toFixed(precision);

      var parts = number.split("."),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
        cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  replacePrice(e) {
    const inputQuantity = Number(e.detail);
    const quantitys = this.config.sort((a, b) => a.discount - b.discount).reverse();

    for (const quantity of quantitys) {
      if (inputQuantity >= quantity.amount) {
        const discountPercent = Math.round(quantity.discount * 100);
        const discountedSingle =
          Math.round(
            quantity.originalPrice * (100 - discountPercent) / 100
          );

        const newPrice = discountedSingle * inputQuantity;
        this.innerHTML = this.formatMoney(newPrice, this.format);
        break;
      }
    }
  }
}

customElements.define("bso-add-to-cart-price", BSO_ADD_TO_CART_PRICE);
